import { useMemo, useState, useEffect } from 'react';
import { fetchInitialConfig, getGlobalConfig } from '../../data/domains/config';

/** Org logo from cached initial config (v2 banner-guest main screen). */
export function useOnboardingData() {
  const [config_generation, set_config_generation] = useState(0);

  useEffect(() => {
    let cancelled = false;
    void fetchInitialConfig().then(() => {
      if (!cancelled) {
        set_config_generation(g => g + 1);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return useMemo(() => {
    const config = getGlobalConfig();
    const org = config?.organization;
    const assets = org?.configurations?.assets;
    const logo_uri =
      typeof assets?.logo === 'string'
        ? assets.logo
        : typeof assets?.actual_logo === 'string'
          ? assets.actual_logo
          : null;
    return {
      org_name: org?.name ?? '',
      org_description: org?.description ?? '',
      logo_uri,
    };
  }, [config_generation]);
}
